import TabList from "@components/TabList";
import { $, $$ } from "@utils/dom";
import { trigger } from "@utils/listener";

class Gate {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.tablist = $('.gate__tablist');
    this.forms = [ ...$$('.gate__tabpanel .gform_wrapper') ].map(form => {
      return {
        el: form,
        visible: form.classList.contains('gform_validation_error'),
      };
    });
  }

  init() {
    if( this.tablist ) this.tablist = new TabList(this.tablist);
    if( this.forms && this.tablist ) {
      const index = this.forms.findIndex(form => form.visible === true);
      if( index > 0 ) trigger(this.tablist.buttons[index], 'click');
    }
  }
}

export default Gate;
